// import { slideVerify } from "../../public/verify-master/js/verify";
import { post, get, formPost } from "../../js/http";
import Cookies from "js-cookie";
import storage from "good-storage";
import { dateToStr, commonFunc } from "../../js/util";

switch (window.location.pathname) {
  case "/":
    $(".km-nav-links .nav-link-index").addClass("active");
    break;
  case "/index.html":
    $(".km-nav-links .nav-link-index").addClass("active");
    break;
  case "/member.html":
    $(".km-nav-links .nav-link-member").addClass("active");
    break;
  case "/recharge.html":
    $(".km-nav-links .nav-link-recharge").addClass("active");
    break;
  case "/callme.html":
    $(".km-nav-links .nav-link-callme").addClass("active");
    break;
  case "/about.html":
    $(".km-nav-links .nav-link-about").addClass("active");
    break;
  default:
    break;
}
let registerData = {
  registerTime: null,
  textCode: null,
  image: null,
};

layui.use(["layer", "form"], function () {
  var $ = layui.jquery,
    layer = layui.layer,
    form = layui.form;
  $(document).ready(function () {
    checkInitUserInfo();
    $("#search_ct").bind("keyup", function (event) {
      if (event.keyCode == "13") {
        //回车执行查询
        window.location.href = "./search.html?text=" + $("#search_ct").val();
      }
    });
    $(".icon-sousuo").click(function () {
      window.location.href = "./search.html?text=" + $("#search_ct").val();
    });
    //切换登录/注册
    $(".ui-dialog-title ul li").on("click", function () {
      $(this).addClass("active").siblings().removeClass("active");
      if ($(this).hasClass("login")) {
        //登录
        $(".login-con").addClass("active");
        $(".register-con").removeClass("active");
      } else {
        //注册
        $(".login-con").removeClass("active");
        $(".register-con").addClass("active");
      }
    });

    //监听账号输入款
    window.checkLoginAcc = function () {
      $("#loginNum").val() === ""
        ? $("#loginNum").siblings().show()
        : $("#loginNum").siblings().hide();
    };
    // 监听密码输入款
    window.checkLoginPasw = function () {
      $("#loginPassword").val() === ""
        ? $("#loginPassword").siblings().show()
        : $("#loginPassword").siblings().hide();
    };
    // 监听注册手机号输入款
    window.checkRegPhone = function () {
      if ($("#phoneNum").val() === "") {
        $("#phoneNum").parent().find("p").show();
      } else {
        $("#phoneNum").parent().find("p").hide();
      }
    };

    window.checkPhoneText = function () {
      if ($("#textCode").val() === "") {
        $("#textCode").parent().find("p").show();
      } else {
        $("#textCode").parent().find("p").hide();
      }
    };

    //点击直接上传图片;
    layui.use(["upload"], function () {
      var $ = layui.jquery,
        upload = layui.upload;
      upload.render({
        elem: "#image-preview",
        acceptMime: "image/*",
        url: "",
        data: {
          type: 1, //上传相册照片
        },
        field: "image",
        auto: false,
        choose: function (obj) {
          console.log("选择文件");
          //预读本地文件示例，不支持ie8
          obj.preview(function (index, file, result) {
            //result  图片链接（base64）
            $("#image-preview").css({
              "background-image": "url(" + result + ")",
              "background-size": "cover",
              "background-position": "center center",
            });
          });
        },
        before: function (obj) {},
        done: function (res) {
          console.log(res);
        },
        error: function () {
          console.log(res);
        },
      });
    });
    // 获取18年前的今天
    var pre = new Date();
    pre.setFullYear(pre.getFullYear() - 18);

    const Y = pre.getFullYear();
    const M = pre.getMonth() + 1;
    const D = pre.getDate();
    const birthday = Y + "-" + M + "-" + D;
    //日期组件
    layui.use("laydate", function () {
      var laydate = layui.laydate;
      //执行一个laydate实例
      laydate.render({
        elem: "#birthdayDate", //指定元素
        value: "1996-01-01", //产品要求写这一天
        max: birthday, //可选最大范围（0代表今天）
      });
    });
  });

  //打开登录窗
  let loginCon;
  window.openLoginCon = function () {
    $(".login").addClass("active").siblings().removeClass("active");
    $(".login-con").addClass("active");
    $(".register-con").removeClass("active");
    loginCon = layer.open({
      type: 1,
      skin: "layer-custom",
      area: ["800px", "400px"],
      title: "",
      id: "loginCon",
      closeBtn: 2,
      content: $("#login-dialog"),
      end: function () {
        $("#login-dialog").hide();
        // 清除获取短信验证码的计时器
        $("#feachBtn").text("获取验证码").removeAttr("disabled");
        $("#feachBtn").css({ color: "#FF5379" });
        clearInterval(countDown);
      },
    });
  };

  //打开注册窗
  window.openRegisterCon = function () {
    registerData.registerTime = dateToStr();
    $(".register").addClass("active").siblings().removeClass("active");
    $(".login-con").removeClass("active");
    $(".register-con").addClass("active");
    layer.open({
      type: 1,
      skin: "layer-custom",
      area: ["800px", "400px"],
      title: "",
      id: "loginCon",
      closeBtn: 2,
      content: $("#login-dialog"),
      end: function () {
        $("#login-dialog").hide();
        // 清除获取短信验证码的计时器
        $("#feachBtn").text("获取验证码").removeAttr("disabled");
        $("#loginNum").val(""); //清空登录账号
        $("#loginPassword").val(""); //清空登录密码
        $("#phoneNum").val(""); //清空注册手机号
        $("#textCode").val(""); //清空注册手机验证码
        $("#feachBtn").css({ color: "#FF5379" });
        clearInterval(countDown);
      },
    });
  };

  //打开canvas验证窗
  window.openCanvasCon = function () {
    var canvasCon;
    if ($("#phoneNum").val().length === 11) {
      //注册滑块验证码实例
      $("#imgVer").slideVerify({
        type: 2, //类型
        vOffset: 5, //误差量，根据需求自行调整
        vSpace: 5, //间隔
        // imgUrl: "https://uploadbeta.com/api/pictures/random?w=400&h=240&",
        // imgName: ["random=1", "random=2", "random=3"],
        imgUrl: "http://r.51callme.com/www/images/CAPTCHA/",
        imgName: [
          "1.jpg",
          "2.jpg",
          "3.jpg",
          "4.jpg",
          "5.jpg",
          "6.jpg",
          "7.jpg",
          "8.jpg",
          "9.jpg",
        ],
        imgSize: {
          width: "400px",
          height: "200px",
        },
        blockSize: {
          width: "40px",
          height: "40px",
        },
        barSize: {
          width: "400px",
          height: "40px",
        },
        ready: function () {},
        success: function () {
          layer.close(canvasCon);
          //从后台获取验证码
          getVerCode("register");
        },
        error: function () {
          console.log("验证失败！");
        },
      });
      canvasCon = layer.open({
        type: 1,
        skin: "layer-custom",
        area: ["440px", ""],
        title: "",
        id: "verBoxCon",
        closeBtn: 2,
        content: $("#verBox"),
        end: function () {
          $("#verBox").hide();
          $("#imgVer").empty();
        },
      });
    } else {
      $("#phoneNum").parent().find("p").text("请输入正确的手机号").show();
    }
  };

  //打开密码重置canvas
  window.openResetCanvas = function () {
    var resetcanvasCon;
    if ($("#resetPsPhoneNum").val().length === 11) {
      //忘记密码滑块验证码实例
      $("#imgResetVer").slideVerify({
        type: 2, //类型
        vOffset: 5, //误差量，根据需求自行调整
        vSpace: 5, //间隔
        // imgUrl: "https://picsum.photos/400/200?",
        // imgUrl: "https://uploadbeta.com/api/pictures/random?w=400&h=240&",
        // imgName: ["random=3", "random=4", "random=6"],
        imgUrl: "http://r.51callme.com/www/images/CAPTCHA/",
        imgName: [
          "1.jpg",
          "2.jpg",
          "3.jpg",
          "4.jpg",
          "5.jpg",
          "6.jpg",
          "7.jpg",
          "8.jpg",
          "9.jpg",
        ],
        imgSize: {
          width: "400px",
          height: "200px",
        },
        blockSize: {
          width: "40px",
          height: "40px",
        },
        barSize: {
          width: "400px",
          height: "40px",
        },
        ready: function () {},
        success: function () {
          console.log("执行登录函数");
          layer.close(resetcanvasCon);
          //从后台获取验证码
          getVerCode("reset");
        },
        error: function () {
          console.log("验证失败！");
        },
      });
      resetcanvasCon = layer.open({
        type: 1,
        skin: "layer-custom",
        area: ["440px", ""],
        title: "",
        id: "verResetBoxCon",
        closeBtn: 2,
        content: $("#verResetBox"),
        end: function () {
          $("#verResetBox").hide();
          $("#imgResetVer").empty();
        },
      });
    } else {
      layer.msg("请输入正确的手机号", { icon: 2 });
    }
  };
  let reDataCon;
  //打开注册资料窗
  window.openReDataCon = function () {
    let provinceJson = require("../../public/province.json");
    let cityJson = require("../../public/city.json");
    $("#provinceSel").html('<option value="">请选择省</option>');
    provinceJson.forEach((province, index) => {
      $("#provinceSel").append(
        '<option value="' +
          province.Id +
          '">' +
          province.ProvinceName +
          "</option>"
      );
    });
    form.render();
    form.on("select(provinceSel)", function (data) {
      let provinceValue = data.value;
      $("#citySel").html('<option value="">请选择市</option>');
      cityJson.forEach((city, index) => {
        if (city.ParentId == provinceValue) {
          $("#citySel").append(
            '<option value="' + city.Id + '">' + city.CityName + "</option>"
          );
        }
      });
      form.render();
      checkReData();
    });
    form.on("select(citySel)", function (data) {
      checkReData();
    });

    reDataCon = layer.open({
      type: 1,
      skin: "layer-custom",
      area: ["600px", ""],
      title: "",
      id: "reDataBoxCon",
      closeBtn: 2,
      content: $("#registerBox"),
      end: function () {
        $("#registerBox").hide();
        $("#image-preview").css({ background: "#e9e9e9" });
        $("#registerBox input[type=image]").val(""); //清空头像
        $("#registerNick").val(""); //清空昵称
        $("#registerPwd").val(""); //清空密码
        $("#registerBox #male").prop("checked", true);
        $("#birthdayDate").val("1996-01-01");
      },
    });
  };

  // 点击登录
  window.toLogin = function () {
    if ($("#loginNum").val() === "") {
      $("#loginNum").siblings().show();
    }
    if ($("#loginPassword").val() === "") {
      $("#loginPassword").siblings().show();
    }
    if ($("#loginNum").val() && $("#loginPassword").val()) {
      LoginRequest();
    }
  };

  $(".login-con").bind("keydown", function (e) {
    var theEvent = e || window.event;
    var code = theEvent.keyCode || theEvent.which || theEvent.charCode;
    if (code == 13) {
      toLogin();
    }
  });

  window.registerToLogin = function () {
    if ($("#phoneNum").val().length != 11) {
      $("#phoneNum").parent().find("p").text("请输入正确的手机号").show();
    }
    if ($("#textCode").val() === "") {
      $("#textCode").parent().find("p").show();
    }

    // if ($("#registerCheckbox").prop("checked") == false) {
    //   layer.msg("您需要阅读并同意《服务条款》《隐私条款》", { icon: 2 });
    //   return;
    // }

    if (
      $("#phoneNum").val().length === 11 &&
      $("#textCode").val().length === 6
    ) {
      let textCode = Cookies.get("messageContent");
      if (md5($("#textCode").val()).toUpperCase() === textCode) {
        //关闭注册窗
        layer.close(loginCon);
        registerData.textCode = $("#textCode").val();

        openReDataCon();
      } else {
        layer.msg("短信验证码已过期", { icon: 2 });
      }
    }
  };

  //忘记密码
  let resetPswCon;
  window.forgetPs = function () {
    resetPswCon = layer.closeAll();
    // 清除获取短信验证码的计时器
    $("#feachBtn").text("获取验证码").removeAttr("disabled");
    $("#feachBtn").css({ color: "#FF5379" });
    clearInterval(countDown);
    layer.open({
      type: 1,
      skin: "layer-custom",
      area: ["500px", ""],
      title: "",
      id: "resetCon",
      closeBtn: 2,
      content: $("#reset-dialog"),
      end: function () {
        $("#reset-dialog").hide();
        // 清除获取短信验证码的计时器
        $("#feachBtn-reset").text("获取验证码").removeAttr("disabled");
        $("#feachBtn-reset").css({ color: "#FF5379" });
        clearInterval(countDownReset);
      },
    });
  };

  /*************************以下点击验证码按钮倒计时*************************/
  let count;
  let countDown = "";
  //获取验证码按钮

  function registerCodeTimer() {
    count = 60;
    doLoop();
    countDown = setInterval(doLoop, 1000);
  }

  function doLoop() {
    if (count > 0) {
      $("#feachBtn").attr("disabled", true);
      $("#feachBtn").css({
        color: "#999",
      });
      $("#feachBtn").text(count + "S重发");
    } else {
      $("#feachBtn").text("重新发送").removeAttr("disabled");
      $("#feachBtn").css({
        color: "#FF5379",
      });
      clearInterval(countDown);
    }
    count--;
  }

  let countReset;
  let countDownReset = "";

  function resetPsCodeTimer() {
    countReset = 60;
    doLoopReset();
    countDownReset = setInterval(doLoopReset, 1000);
  }

  function doLoopReset() {
    if (countReset > 0) {
      $("#feachBtn-reset").attr("disabled", true);
      $("#feachBtn-reset").css({
        color: "#999",
      });
      $("#feachBtn-reset").text(countReset + "S重发");
    } else {
      $("#feachBtn-reset").text("重新发送").removeAttr("disabled");
      $("#feachBtn-reset").css({
        color: "#FF5379",
      });
      clearInterval(countDownReset);
    }
    countReset--;
  }

  /*************************以上点击验证码按钮倒计时*************************/
  let couponCon;
  //打开体验券
  function openCouponCon() {
    post("/ApiHome/ApiAction?_ControlName=GetUserFreeCall").then((res) => {
      if (res.ReturnStatus) {
        if (res.Data && res.Data.OnlyOneData && res.Data.OnlyOneData.length) {
          //设置通话券可用时长
          $("#coupon-avail-t").text(
            res.Data.OnlyOneData.TotalFreeCallMinutes + "分钟"
          );
          $("#coupon-avail-des").text(
            "可拨打" +
              res.Data.OnlyOneData.TotalFreeCallMinutes +
              "分钟免费咨询电话"
          );
          $("#coupon-avail-deadline").text(
            res.Data.OnlyOneData.EndTime + "过期"
          );

          couponCon = layer.open({
            type: 1,
            skin: "layer-custom",
            area: ["600px", ""],
            title: "",
            id: "ticketBoxCon",
            closeBtn: 2,
            content: $("#ticketBox"),
            end: function () {
              $("#ticketBox").hide();
            },
          });
          $("#ticketBoxCon .cancelbtn").click(function () {
            layer.close(couponCon);
          });

          $("#ticketBoxCon .confirmbtn").click(function () {
            layer.close(couponCon);
            require("../../page/personal/account/coupon/couponExp");
          });
        } else {
          setTimeout(() => {
            location.reload();
          });
        }
      } else {
        setTimeout(() => {
          location.reload();
        });
      }
    });
  }

  function getVerCode(type) {
    post("/ApiHome/ApiAction?_ControlName=GetVerificationCode").then((res) => {
      if (res.ReturnStatus) {
        switch (type) {
          case "register":
            getRegisterTextCode(res.Data.RandomNumber, res.Data.CodeSign);
            break;
          case "reset":
            getResetTextCode(res.Data.RandomNumber, res.Data.CodeSign);
            break;
        }
      }
    });
  }
  //获取注册短信验证码
  function getRegisterTextCode(verRandomNum, verCodeSign) {
    var data = {
      PhoneNumber: $("#phoneNum").val(),
      RandomNumber: verRandomNum,
      CodeSign: verCodeSign,
    };
    post("/ApiHome/ApiAction?_ControlName=UserRegisterBeginForPC", data).then(
      (res) => {
        if (res.ReturnStatus) {
          registerCodeTimer();
          layer.msg(res.MessageCN, { icon: 1 });
          //保存messageContent 30分钟
          setCookies("messageContent", res.Data.MessageContent, 30 * 60);
        } else {
          layer.msg(res.MessageCN, { icon: 2 });
        }
      }
    );
  }

  //完成注册
  var isRun = true;
  window.comRegister = function () {
    if ($($(".complete-re-submit")[0]).hasClass("active")) {
      let formData = new FormData();
      formData.append("NickName", $("#registerNick").val());
      formData.append("LoginPassWord", $("#registerPwd").val());
      formData.append(
        "Sex",
        $("#sexcon").find("input[name='sex']:checked").val()
      );
      formData.append("Birthday", $("#birthdayDate").val());
      formData.append("PhoneNumber", $("#phoneNum").val());
      formData.append("AddTime", registerData.registerTime);
      formData.append("MessageContent", registerData.textCode);
      formData.append(
        "image",
        $("#image-preview").parent().find('input[type="file"]')[0].files[0]
      );
      formData.append("FromID", 1001);
      formData.append("Province", $("#lay-province input")[0].value);
      formData.append("City", $("#lay-city input")[0].value);
      if (isRun) {
        requestRegister();
        setTimeout(function () {
          isRun = true;
        }, 5000); //点击后相隔多长时间可执行
      }
      function requestRegister() {
        formPost(
          "/ApiHome/ApiAction?_ControlName=UserRegisterMainForPC",
          formData
        ).then((res) => {
          isRun = false;
          if (res.ReturnStatus) {
            //登录者的信息
            storage.set("userInfo", res.Data.CurrentUserInf);
            Cookies.set("registerCode", res.Data.RegisterCode);
            Cookies.set("userInfo", res.Data.CurrentUserInf, { expires: 7 });
            layer.msg(res.MessageCN, { icon: 1 });
            // 关闭注册弹窗 和 注册信息弹窗
            layer.closeAll("page");
            // 获取免费赠送券
            openCouponCon();
          } else {
            layer.msg(res.MessageCN, { icon: 2 });
          }
        });
      }
    }
  };

  //获取重置密码短信验证码
  function getResetTextCode(verRandomNum, verCodeSign) {
    var data = {
      PhoneNumber: $("#resetPsPhoneNum").val(),
      RandomNumber: verRandomNum,
      CodeSign: verCodeSign,
    };
    post("/ApiHome/ApiAction?_ControlName=ReSetPasswordBeginByPC", data).then(
      (res) => {
        if (res.ReturnStatus) {
          resetPsCodeTimer();
          layer.msg(res.MessageCN, { icon: 1 });
          //保存resetMsgContent 30分钟
          setCookies("resetMsgContent", res.Data.MessageContent, 30 * 60);
        } else {
          layer.msg(res.MessageCN, { icon: 2 });
        }
      }
    );
  }

  window.confirmReset = function () {
    var data = {
      PhoneNumber: $("#resetPsPhoneNum").val(),
      NewPassWord: $("#resetPs").val(),
      MessageContent: $("#resetVerCode").val(),
    };
    post("/ApiHome/ApiAction?_ControlName=ReSetPasswordMainByPC", data).then(
      (res) => {
        if (res.ReturnStatus) {
          layer.close(resetPswCon);
          layer.msg(res.MessageCN, { icon: 1 });
          setTimeout(() => {
            openLoginCon();
          }, 1500);
        } else {
          layer.msg(res.MessageCN, { icon: 2 });
        }
      }
    );
  };

  function LoginRequest() {
    let accountID = $("#loginNum").val(),
      password = $("#loginPassword").val();
    let data = {
      AccountID: accountID,
      Password: password,
      _AppID: 103, //PC
    };
    post("/ApiHome/ApiAction?_ControlName=UserLoginByUserNameForPC", data).then(
      (res) => {
        if (res.ReturnStatus) {
          //登录者的信息
          storage.set("userInfo", res.Data.CurrentUserInf);
          Cookies.set("registerCode", res.Data.RegisterCode);
          Cookies.set("userInfo", res.Data.CurrentUserInf, { expires: 7 });
          if ($("#audtoLoginCB").attr("checked")) {
            Cookies.set("userName", accountID, { expires: 7 });
            Cookies.set("passWord", password, { expires: 7 });
          }
          //设置右上角的信息
          setInitUserInfo(res.Data.CurrentUserInf);
          layer.closeAll();
          layer.msg(res.MessageCN, { icon: 1 });
          setTimeout(() => {
            location.reload();
          });
        } else {
          layer.msg(res.MessageCN, { icon: 2 });
        }
      }
    );
  }

  //判断是否有登录者信息
  function checkInitUserInfo() {
    let userInfo = storage.get("userInfo");
    if (userInfo) {
      post("/ApiHome/ApiAction?_ControlName=GetUserBaseInfForPC", {
        UserID: userInfo.UserID,
      }).then((res) => {
        if (res.ReturnStatus) {
          if (res.Data.UserID === userInfo.UserID) {
            // 确认不串号
            //更新本地userInfo
            storage.set("userInfo", res.Data);
            setInitUserInfo(res.Data);
            // if (res.Data.FreeTicketCount > 0) {
            //   getFreeCoupon({ UserID: userInfo.UserID });
            // }
          } else {
            storage.clear();
            Cookies.remove("userName");
            Cookies.remove("registerCode");
            Cookies.remove("userInfo");
            let loginStr =
              '<div class="btn-group"><span id="login" onclick="openLoginCon()">登录</span><span id="register" onclick="openRegisterCon()">注册</span > </div>';
            $("#headerInfo").html(loginStr);
            window.location.href = "./index.html";
          }
        } else {
          // 登录失效
          storage.remove("userInfo", res.Data);
          $("#loading") && $("#loading").hide();
        }
      });
    } else {
      $("#loading").hide();
      if (window.location.pathname === "/index.html") {
        // openLoginCon();
      }
    }
  }
  //设置右上角的信息
  function setInitUserInfo(info) {
    let headerInfoStr =
      '<a href="javascript:;" class="nickName" onmouseenter="userEnter()" onmouseleave="userLeaver()"><cite>' +
      info.NickName +
      '</cite> <i class="iconfont icon-dropdown"></i></a><a href="./personal.html" class="headerImg"><img src="' +
      info.DataUrl +
      '"/></a>';
    $("#headerInfo .btn-group").html(headerInfoStr);
    $("#login-info-avatar").attr("src", info.DataUrl);
    $("#login-info-nickName").text(info.NickName);
    $("#login-info-meter").text("考米号：" + info.MeterNo);
    info.TotalCanUseCash == null
      ? (info.TotalCanUseCash = "0.00")
      : info.TotalCanUseCash == info.TotalCanUseCash;
    $("#login-info-yue").text("账户余额：" + info.TotalCanUseCash);
    $("#login-info-avatar").attr("src", info.DataUrl);
    $("#homeLink").attr("href", "./home.html?userid=" + info.UserID);
    $("#loading").hide();
  }

  window.userEnter = function () {
    $("#headerInfo .nickName i")
      .removeClass("icon-dropdown")
      .addClass("icon-dropup");
    $("#headerInfo .login-menu-con").show();
  };

  window.userLeaver = function () {
    $("#headerInfo .nickName i")
      .removeClass("icon-dropup")
      .addClass("icon-dropdown");
    $("#headerInfo .login-menu-con").hide();
  };

  //退出账号清除登录者信息
  window.quiteAcc = function () {
    post("/ApiHome/ApiAction?_ControlName=CurrentUserLogOutByPC").then(
      (res) => {
        if (res.ReturnStatus) {
          storage.clear();
          Cookies.remove("userName");
          Cookies.remove("registerCode");
          Cookies.remove("userInfo");
          Cookies.remove("CallMe_PC");
          let loginStr =
            '<div class="btn-group"><span id="login" onclick="openLoginCon()">登录</span><span id="register" onclick="openRegisterCon()">注册</span > </div>';
          $("#headerInfo").html(loginStr);
          window.location.href = "./index.html";
        }
      }
    );
  };

  //设置保存cookies时间
  function setCookies(key, value, expiresTime) {
    let seconds = expiresTime;
    let expires = new Date(new Date() * 1 + seconds * 1000);
    return Cookies.set(key, value, { expires: expires });
  }

  $("#serveTerm-btn").click(function () {
    post("/ApiHome/ApiAction?_ControlName=GetInformationConfigByPC", {
      KeyName: "UserServiceAgreement",
    }).then((res) => {
      if (res.ReturnStatus) {
        let aboutusStr = res.Data.InfoConfig.KeyValue;
        commonFunc(aboutusStr);
      }
    });
  });

  $("#privacyTerm-btn").click(function () {
    post("/ApiHome/ApiAction?_ControlName=GetInformationConfigByPC", {
      KeyName: "UserPrivacyPolicy",
    }).then((res) => {
      if (res.ReturnStatus) {
        let aboutusStr = res.Data.InfoConfig.KeyValue;
        commonFunc(aboutusStr);
      }
    });
  });

  function urlPopCon(url) {
    $(".publicPop-content-con").html(
      "<iframe src=" +
        url +
        ' width="100%" height="600px" scrolling="no"></iframe>'
    );
    let privacyLayer = layer.open({
      type: 1,
      skin: "layer-custom",
      area: ["600px", ""],
      title: "",
      id: "publicPopCon",
      closeBtn: 0,
      content: $("#publicPop"),
      end: function () {
        $("#publicPop").hide();
      },
    });
    $("#publicPop .icon-close").click(function () {
      layer.close(privacyLayer);
    });
  }

  if (!Cookies.get("MachineRegistration") && storage.get("userInfo")) {
    post("/ApiHome/ApiAction?_ControlName=MachineRegistration", {
      ChannelID: 1,
      FromCompanyID: 1,
      UserID: storage.get("userInfo").UserID,
    }).then((res) => {
      // 6个小时
      setCookies("MachineRegistration", res.Data.OnlyOneData, 6 * 60 * 60);
    });
  }
});

function getFreeCoupon(data) {
  post("/ApiHome/ApiAction?_ControlName=GetUserFreeTicketListByPC", data).then(
    (res) => {
      if (res.ReturnStatus) {
        const res = {
          ReturnStatus: true,
          MessageID: 10010,
          MessageCN: "获取数据成功",
          Data: {
            OnlyOneData: [
              {
                TotalFreeCallMinutes: 6,
                TypeName: "免费通话券",
                EndTime: "2019-10-22",
                IsValid: 0,
              },
            ],
          },
        };
        let dailyCouponTemp = require("./dailyCoupon.art");
        let dailyCouponHtml = dailyCouponTemp({
          dailyFreeCoupon: res.Data.OnlyOneData[0],
        });
        $("#freeCoupon .freeCoupon-content").html(dailyCouponHtml);
        dailyCouponPop();
      }
    }
  );
}
function dailyCouponPop() {
  let dailyCouponLayer = layer.open({
    type: 1,
    skin: "daily-coupon",
    area: ["598px", "598px"],
    title: "",
    id: "freeCouponCon",
    closeBtn: 0,
    content: $("#freeCoupon"),
    end: function () {
      $("#freeCoupon").hide();
    },
  });
  $("#freeCoupon .close").click(function () {
    layer.close(dailyCouponLayer);
  });
  $("#freeCoupon .cancelbtn").click(function () {
    layer.close(dailyCouponLayer);
  });
}

window.checkReData = function () {
  if (
    $("#registerNick").val() &&
    $("#registerPwd").val() &&
    $("#registerPwd").val().trim().length >= 6 &&
    $("#provinceSel").val() &&
    $("#citySel").val()
  ) {
    $(".complete-re-submit").addClass("active");
  } else {
    $(".complete-re-submit").removeClass("active");
  }
};
